import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function ProductSearchBar({ value, onChange, placeholder = "Buscar..." }) {
    return (
        <div className="tw-relative tw-w-full">
        <MagnifyingGlassIcon className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 tw-h-4 tw-w-4 -tw-translate-y-1/2 tw-text-slate-400" />
        <input
            type="text"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            placeholder={placeholder}
            className="tw-w-full tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-100 tw-py-2 tw-pl-9 tw-pr-3 tw-text-sm tw-text-slate-700 tw-outline-none tw-transition focus:tw-border-cyan-400 focus:tw-bg-white focus:tw-ring-2 focus:tw-ring-cyan-100"
        />
        </div>
    );
}